import copy from 'copy-to-clipboard';
import {observer} from 'mobx-react';
import React from 'react';

import CopyIcon from '@udemy/icons/dist/copy.ud-icon';
import {Button, IconButton} from '@udemy/react-core-components';
import {FooterButtons} from '@udemy/react-dialog-components';
import {FormGroup, TextInput} from '@udemy/react-form-components';

import {CreateModalStore} from 'src/stores/create-modal-store';

import styles from '../create-modal.module.less';

export const ClientCreatedStep = observer(({store}: {store: CreateModalStore}) => {
    if (!store.createdClient) {
        return null;
    }

    return (
        <>
            <div className={styles['client-created-step']}>
                <p>
                    Please save this secret key somewhere safe and accessible. For security reasons,{' '}
                    <b>you won’t be able to view it again</b> through your Udemy Developer account.
                    If you lose this secret key, you’ll need to generate a new one.
                </p>

                <FormGroup label="Client ID">
                    <div className={styles['client-field-container']}>
                        <TextInput
                            className={styles['client-field-input']}
                            value={store.createdClient.clientId}
                            readOnly={true}
                            data-testid="client-id"
                        />
                        <IconButton
                            udStyle="secondary"
                            onClick={() =>
                                store.createdClient && copy(store.createdClient.clientId)
                            }
                        >
                            <CopyIcon />
                        </IconButton>
                    </div>
                </FormGroup>

                <FormGroup label="Client Secret">
                    <div className={styles['client-field-container']}>
                        <TextInput
                            className={styles['client-field-input']}
                            value={store.createdClient.clientSecret}
                            readOnly={true}
                            data-testid="client-secret"
                        />
                        <IconButton
                            udStyle="secondary"
                            onClick={() =>
                                store.createdClient && copy(store.createdClient.clientSecret)
                            }
                        >
                            <CopyIcon />
                        </IconButton>
                    </div>
                </FormGroup>
            </div>
            <FooterButtons>
                <Button onClick={() => store.close()}>Done</Button>
            </FooterButtons>
        </>
    );
});
